import { render, staticRenderFns } from "./AdventureTour4.vue?vue&type=template&id=238cfe32&scoped=true&"
import script from "./AdventureTour4.vue?vue&type=script&lang=ts&"
export * from "./AdventureTour4.vue?vue&type=script&lang=ts&"
import style0 from "./AdventureTour4.vue?vue&type=style&index=0&id=238cfe32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238cfe32",
  null
  
)

export default component.exports